import { phoneHref } from '@/utils/formatPhone'
import { formatPhone } from '@/utils.ts'

export type PhoneLinkProps = {
  phone: string | undefined | null
  /** Rendered when there is no phone value. Defaults to '-'. */
  fallback?: string
}

/** Clickable `tel:` link showing the phone as `646-220-4565` (PD-1133). */
export function PhoneLink({ phone, fallback = '-' }: PhoneLinkProps) {
  if (!phone) return <>{fallback}</>
  return (
    <a
      href={phoneHref(phone)}
      // Anchors often sit inside rows with their own navigation onClick.
      onClick={(e) => e.stopPropagation()}
      className="text-inherit underline-offset-2 hover:underline"
    >
      {formatPhone(phone)}
    </a>
  )
}
